export { default } from './DeviceDetect'
export { BrowserView, MobileView, TabletView , BrowserAndTabletView, MobileAndTabletView} from './DeviceDetect'
export { DeviceDetectProvider } from './DeviceDetect'
